import { calculationLimits } from "./calculation.config";

const parseErrorNumbers = (value) => {
    const rounded = Math.round(value * 1000) / 1000;
    if(Number.isInteger(rounded)) return rounded.toString();
    return rounded.toFixed(3);
}

export const errors = {

    // #region access
    ACCESS_LOGIN_DETAILS_TOO_SHORT:
    {
        error: 'ACCESS_LOGIN_DETAILS_TOO_SHORT',
        state: 'warning',
        title: 'Innloggindsdetaljer for kort.',
        description: 'Brukernavn og passord må være minst 3 tegn.',
        autoUnset: true,
    },

    ACCESS_LOGIN_DETAILS_WRONG:
    {
        error: 'ACCESS_LOGIN_DETAILS_WRONG',
        state: 'error',
        title: 'Brukernavn eller passord er feil.',
        description: 'Oppgitte innloggingsdetaljer passer ikke til noen registrerte brukere.',
        autoUnset: false,
    },
    ACCESS_ACTIVATION_DETAILS_TOO_SHORT:
    {
        error: 'ACCESS_ACTIVATION_DETAILS_TOO_SHORT',
        state: 'warning',
        title: 'Aktiveringsdetaljert for kort.',
        description: 'Brukernavn og koder er for korte.',
        autoUnset: true,
    },
    ACCESS_ACTIVATION_USER_NOT_FOUND:
    {
        error: 'ACCESS_ACTIVATION_USER_NOT_FOUND',
        state: 'error',
        title: 'Bruker eksisterer ikke.',
        description: "Bruker med oppgitt brukernavn og koder eksisterer ikke.",
        autoUnset: true,
    },
    ACCESS_ACTIVATION_USER_ACTIVE:
    {
        error: 'ACCESS_ACTIVATION_USER_ACTIVE',
        state: 'success',
        title: 'Bruker allerede aktivert',
        description: "Bruker allerede aktivert, gå tilbake og logg inn.",
        autoUnset: true,
    },
    ACCESS_ACTIVATION_USER_BLOCKED:
    {
        error: 'ACCESS_ACTIVATION_USER_BLOCKED',
        state: 'error',
        title: 'Bruker er blokkert.',
        description: 'Bruker er blokkert og kan ikke aktiveres eller tilbakeføres. Kontakt administrator.',
        autoUnset: true,
    },
    ACCESS_ACTIVATION_PASSWORD_NOT_VALID:
    {
        error: 'ACCESS_ACTIVATION_PASSWORD_NOT_VALID',
        state: 'error',
        title: 'Passord ikke riktig.',
        description: 'Passord oppfyller ikke alle krav.',
        autoUnset: true,
    },
    ACCESS_ACTIVATION_TERMS_OF_USE_NOT_VALID:
    {
        error: 'ACCESS_ACTIVATION_TERMS_OF_USE_NOT_VALID',
        state: 'error',
        title: 'Vilkår for bruk må godkjennes.',
        autoUnset: true,
    },
    ACCESS_ACTIVATION_USER_NOT_ACTIVATED:
    {
        error: 'ACCESS_ACTIVATION_USER_NOT_FOUND',
        state: 'error',
        title: 'Passord ikke aktivert.',
        description: 'Bruker ikke funnet, passord er ikke satt og bruker ble ikke aktivert.',
        autoUnset: true,
    },
    ACCESS_ACTIVATION_USER_ACTIVATED:
    {
        error: 'ACCESS_ACTIVATION_USER_ACTIVATED',
        state: 'success',
        title: 'Bruker aktivert',
        description: 'Bruker er aktivert. Du blir sendt til innlogging om kort tid.',
        autoUnset: true,
    },
    // #endregion access

    // #region project
    PROJECT_STATUS_CONTROLLED_BY_ACTIVITY:
    {
        error: 'PROJECT_STATUS_CONTROLLED_BY_ACTIVITY',
        state: 'warning',
        title: 'Prosjektstatus er styrt av aktivitet.',
        description: 'Status av prosjektet er styrt av aktivitet, og kan ikke endres ved å dra.',
        autoUnset: true,
    },

    PROJECT_ARCHIVED:
    {
        error: 'PROJECT_ARCHIVED',
        state: 'success',
        title: 'Prosjekt arkivert.',
        autoUnset: true,
    },

    PROJECT_NAME_TOO_SHORT:
    {
        error: 'PROJECT_NAME_TOO_SHORT',
        state: 'error',
        title: 'Prosjektnavn for kort.',
        description: 'Prosjektnavn må være minst 5 tegn.',
        autoUnset: false,
    },

    PROJECT_NAME_TOO_LONG:
    {
        error: 'PROJECT_NAME_TOO_LONG',
        state: 'error',
        title: 'Prosjektnavn for kort.',
        description: 'Prosjektnavn kan være maksimalt 50 tegn.',
        autoUnset: false,
    },

    PROJECT_NUMBER_TOO_SHORT:
    {
        error: 'PROJECT_NUMBER_TOO_SHORT',
        state: 'error',
        title: 'Prosjektnummer for kort.',
        description: 'Prosjektnavn må være minst 3 tegn.',
        autoUnset: false,
    },

    PROJECT_NUMBER_TOO_LONG:
    {
        error: 'PROJECT_NUMBER_TOO_LONG',
        state: 'error',
        title: 'Prosjektnummer for lang.',
        description: 'Prosjektnavn kan være maksimalt 10 tegn.',
        autoUnset: false,
    },

    PROJECT_VERSIONS_MISSING_NTM:
    {
        error: 'PROJECT_VERSIONS_MISSING_NTM',
        state: 'error',
        title: 'Versjonslogg ikke tilgjengelig.',
        description: 'Versjonslogg krever at det er satt et gyldig NTM-sone i kartet.',
        autoUnset: true,
    },

    PROJECT_DELIVERIES_TITLE_TOO_SHORT:
    {
        error: 'PROJECT_DELIVERIES_TITLE_TOO_SHORT',
        state: 'error',
        title: 'Tittel for leveranse for kort.',
        description: 'Tittel må være minst 5 tegn',
        autoUnset: true,
    },

    PROJECT_DELIVERIES_TITLE_TOO_LONG:
    {
        error: 'PROJECT_DELIVERIES_TITLE_TOO_LONG',
        state: 'error',
        title: 'Tittel for leveranse for lang.',
        description: 'Tittel kan være maks 30 tegn',
        autoUnset: true,
    },

    PROJECT_DELIVERIES_CONTACT_TOO_SHORT:
    {
        error: 'PROJECT_DELIVERIES_CONTACT_TOO_SHORT',
        state: 'error',
        title: 'Kontaktperson for leveranse for kort.',
        description: 'Tittel må være minst 5 tegn',
        autoUnset: true,
    },

    PROJECT_DELIVERIES_CONTACT_TOO_LONG:
    {
        error: 'PROJECT_DELIVERIES_CONTACT_TOO_LONG',
        state: 'error',
        title: 'Kontaktperson for leveranse for lang.',
        description: 'Tittel kan være maks 30 tegn',
        autoUnset: true,
    },

    // #endregion project
    
    // #region tasks
    TASK_PROJECT_NOT_SET:
    {
        error: 'TASK_PROJECT_NOT_SET',
        state: 'error',
        title: 'Oppgave må være tilknyttet til prosjektet.',
        autoUnset: false,
    },

    TASK_PRIORITY_NOT_SET:
    {
        error: 'TASK_PRIORITY_NOT_SET',
        state: 'error',
        title: 'Oppgavens prioritet mangler.',
        autoUnset: false,
    },

    TASK_DURATION_IS_NULL:
    {
        error: 'TASK_DURATION_IS_NULL',
        state: 'error',
        title: 'Arbeidsmengde kan ikke være null.',
        autoUnset: false,
    },

    TASK_DEADLINE_BEFORE_STARTDATE:
    {
        error: 'TASK_DEADLINE_BEFORE_STARTDATE',
        state: 'error',
        title: 'Startdato må være før frist.',
        autoUnset: false,
    },

    TASK_TITLE_TOO_SHORT:
    {
        error: 'TASK_TITLE_TOO_SHORT',
        state: 'error',
        title: 'Opgpavetittel for kort.',
        description: "Tittelen må være minst 5 tegn.",
        autoUnset: false,
    },

    TASK_TITLE_TOO_LONG:
    {
        error: 'TASK_TITLE_TOO_LONG',
        state: 'error',
        title: 'Opgpavetittel for lang.',
        description: "Tittelen kan være maks 100 tegn.",
        autoUnset: false,
    },

    TASK_ARCHIVED:
    {
        error: 'TASK_ARCHIVED',
        state: 'success',
        title: 'Oppgave arkivert.',
        autoUnset: true,
    },
    // #endregion

    // #region notes
    NOTEBOOK_ARCHIVED:
    {
        error: 'NOTEBOOK_ARCHIVED',
        state: 'success',
        title: 'Mappe arkivert.',
        autoUnset: true,
    },
    NOTES_FOLDERNAME_TOO_SHORT:
    {
        error: 'NOTES_FOLDERNAME_TOO_SHORT',
        state: 'warning',
        title: 'Notatboknavn for kort.',
        description: "Tittelen må være minst 5 tegn.",
        autoUnset: true,
    },

    NOTES_FOLDERNAME_TOO_LONG:
    {
        error: 'NOTES_FOLDERNAME_TOO_LONG',
        state: 'warning',
        title: 'Notatboknavn for lang.',
        description: "Tittelen kan være maks 45 tegn.",
        autoUnset: true,
    },

    NOTES_NOTETITLE_TOO_SHORT:
    {
        error: 'NOTES_NOTETITLE_TOO_SHORT',
        state: 'warning',
        title: 'Notattittel for kort.',
        description: "Tittelen må være minst 5 tegn.",
        autoUnset: true,
    },
    
    NOTES_NOTETITLE_TOO_LONG:
    {
        error: 'NOTES_NOTETITLE_TOO_LONG',
        state: 'warning',
        title: 'Notattittel for lang.',
        description: "Tittelen kan være maks 100 tegn.",
        autoUnset: true,
    },

    NOTES_RENAME_VERSION_MISMATCH:
    {
        error: 'NOTES_RENAME_VERSION_MISMATCH',
        state: 'warning',
        title: 'Utdatert tittel',
        description: "Tittelen er utdatert. Oppdatert til nyeste versjon.",
        autoUnset: true,
    },
    NOTE_ARCHIVED:
    {
        error: 'NOTE_ARCHIVED',
        state: 'success',
        title: 'Notat arkivert.',
        autoUnset: true,
    },
    NOTE_CONTENT_ARCHIVED:
    {
        error: "NOTE_CONTENT_ARCHIVED",
        state: 'error',
        title: 'Notat er arkivert',
        description: "Notater er arkivert og kan ikke redigeres.",
        autoUnset: false,
    },
    NOTE_TITLE_UPDATED_CONTENT_CONFLICT:
    {
        error: "NOTE_TITLE_UPDATED_CONTENT_CONFLICT",
        state: 'warning',
        title: 'Innholdet ble oppdatert i bakgrunnen.',
        autoUnset: true,
    },
    NOTE_TITLE_CONFLICT_CONTENT_UPDATED:
    {
        error: "NOTE_TITLE_CONFLICT_CONTENT_UPDATED",
        state: 'warning',
        title: 'Titeelen ble oppdatert i bakgrunnen.',
        autoUnset: true,
    },
    NOTE_TITLE_CONFLICT_CONTENT_CONFLICT:
    {
        error: "NOTE_TITLE_UPDATED_CONTENT_CONFLICT",
        state: 'warning',
        title: 'Tittelen og innhold ble oppdatert i bakgrunnen.',
        autoUnset: true,
    },
    // #endregion

    // #region toolks
    TOOLS_SPEEDLIMIT_TOO_LOW:
    {
        error: 'TOOLS_SPEEDLIMIT_TOO_LOW',
        state: 'error',
        title: 'Ugyldig fartsgrense',
        description: "Fartsgrensen kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minSpeed) + " km/t.",
        autoUnset: false,
    },
    TOOLS_SPEEDLIMIT_TOO_HIGH:
    {
        error: 'TOOLS_SPEEDLIMIT_TOO_LOW',
        state: 'error',
        title: 'Ugyldig fartsgrense',
        description: "Fartsgrensen kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxSpeed) + " km/t.",
        autoUnset: false,
    },
    TOOLS_INITIAL_SPEED_TOO_LOW:
    {
        error: 'TOOLS_INITIAL_SPEED_TOO_LOW',
        state: 'error',
        title: 'Ugyldig startfart',
        description: "Startfarten kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minSpeed) + " km/t.",
        autoUnset: false,
    },
    TOOLS_INITIAL_SPEED_TOO_HIGH:
    {
        error: 'TOOLS_INITIAL_SPEED_TOO_HIGH',
        state: 'error',
        title: 'Ugyldig startfart',
        description: "Startfarten kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxSpeed) + " km/t.",
        autoUnset: false,
    },
    TOOLS_HORIZONTAL_RADIUS_IS_EQUAL_ZERO:
    {
        error: "TOOLS_HORIZONTAL_RADIUS_IS_EQUAL_ZERO",
        state: 'error',
        title: 'Ugyldig radius.',
        description: "Horisontalkurveradius kan ikke være null.",
        autoUnset: false,
    },
    TOOLS_CROSS_SLOPE_TOO_LOW:
    {
        error: "TOOLS_CROSS_SLOPE_TOO_LOW",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Tverfall kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minCrossSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_CROSS_SLOPE_TOO_HIGH:
    {
        error: "TOOLS_CROSS_SLOPE_TOO_HIGH",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Tverfall kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxCrossSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_SUPERELEVATION_TOO_LOW:
    {
        error: "TOOLS_SUPERELEVATION_TOO_LOW",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Overhøyde kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minCrossSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_SUPERELEVATION_TOO_HIGH:
    {
        error: "TOOLS_SUPERELEVATION_TOO_HIGH",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Overhøyde kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxCrossSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_LONGITUDAL_SLOPE_TOO_LOW:
    {
        error: "TOOLS_LONGITUDAL_SLOPE_TOO_LOW",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Stigningen kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minLongitudalSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_LONGITUDAL_SLOPE_TOO_HIGH:
    {
        error: "TOOLS_LONGITUDAL_SLOPE_TOO_HIGH",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Stigningen kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxLongitudalSlope) + " m/m.",
        autoUnset: false,
    },
    TOOLS_LIGHTS_HEIGHT_TOO_LOW:
    {
        error: "TOOLS_LIGHTS_HEIGHT_TOO_LOW",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Lysetshøyde over bakken kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minLightsHeight) + " m.",
        autoUnset: false,
    },
    TOOLS_LIGHTS_HEIGHT_TOO_HIGH:
    {
        error: "TOOLS_LIGHTS_HEIGHT_TOO_HIGH",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Lysetshøyde over bakken kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxLightsHeight) + " m.",
        autoUnset: false,
    },
    TOOLS_LIGHTS_ANGLE_TOO_LOW:
    {
        error: "TOOLS_LIGHTS_ANGLE_TOO_LOW",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Lysets åpningsvinkel kan ikke være lavere enn " + parseErrorNumbers(calculationLimits.minLightsAngle) + " °.",
        autoUnset: false,
    },
    TOOLS_LIGHTS_ANGLE_TOO_HIGH:
    {
        error: "TOOLS_LIGHTS_ANGLE_TOO_HIGH",
        state: 'error',
        title: 'Ugyldig overhøyde.',
        description: "Lysets åpningsvinkel kan ikke være større enn " + parseErrorNumbers(calculationLimits.maxLightsAngle) + " °.",
        autoUnset: false,
    },
    TOOLS_LONGITUDAL_SLOPES_DO_NOT_FORM_CREST_CURVE:
    {
        error: "TOOLS_LONGITUDAL_SLOPES_DO_NOT_FORM_CREST_CURVE",
        state: 'warning',
        title: 'Stigninger danner ikke høybrekk',
        description: "Kombinasjon av stininger danner ikke et høybrekk.",
        autoUnset: false,
    },
    TOOLS_BRAKING_FRICTION_CALCULATED_BY_REGRESSION:
    {
        error: "TOOLSS_BRAKING_FRICTION_CALCULATED_BY_REGRESSION",
        state: 'success',
        title: 'Bremsefriksjon er beregnet ved bruk av regresjon.',
        autoUnset: true,
    },
    TOOLS_RADIUS_DIRECTION_CORRECTED:
    {
        error: "TOOLS_RADIUS_DIRECTION_CORRECTED",
        state: 'success',
        title: 'Horisontal radius korrigert til riktig fortegn.',
        autoUnset: true,
    },
    TOOLS_RAMP_RADIUS_LOWER_THAN_MAIN_ROAD_RADIUS:
    {
        error: "TOOLS_RAMP_RADIUS_LOWER_THAN_MAIN_ROAD_RADIUS",
        state: 'error',
        title: 'Radius på rampen ugyldig.',
        description: 'Radius på rampen kan ikke være mindre enn radius på hovedvegen.',
        autoUnset: false,
    },
    TOOLS_RAMP_RADIUS_HIGHER_THAN_MAIN_ROAD_RADIUS:
    {
        error: "TOOLS_RAMP_RADIUS_HIGHER_THAN_MAIN_ROAD_RADIUS",
        state: 'error',
        title: 'Radius på rampen ugyldig.',
        description: 'Radius på rampen kan ikke være større enn radius på hovedvegen.',
        autoUnset: false,
    },
    TOOLS_RAMP_CONNECTION_CROSS_SLOPE_NOT_BETWEEN_RAMP_AND_MAIN_ROAD_CROSS_SLOPE:
    {
        error: "TOOLS_RAMP_RADIUS_HIGHER_THAN_MAIN_ROAD_RADIUS",
        state: 'warning',
        title: 'Unaturlig tverrfall på rampetilutning.',
        description: 'Tverrfall ved rampetilslutning bør være et verdi mellom tverrfall på rampeen og hovedvegen.',
        autoUnset: false,
    },
    TOOLS_RAMP_CONNECTION_AND_MAIN_ROAD_CROSS_SLOPE_DIFFERENCE_TOO_HIGH:
    {
        error: "TOOLS_RAMP_CONNECTION_AND_MAIN_ROAD_CROSS_SLOPE_DIFFERENCE_TOO_HIGH",
        state: 'warning',
        title: 'Stor differanse mellom tverrfall på hovedvegen og rampetilslutning.',
        description: 'Differansen mellom tverrfallet på rampetilslutning og hovedvegen bør ikke overstige 0.05 m/m.',
        autoUnset: false,
    },
    TOOLS_CROSS_SLOPE_DIRECTION_CORRECTED:
    {
        error: "TOOLS_CROSS_SLOPE_DIRECTION_CORRECTED",
        state: 'success',
        title: 'Retningen på tverrfall korrigert til riktig fortegn.',
        autoUnset: true,
    },
    TOOLS_INTIIAL_SPEED_BELOW_REQUIRMENTS:
    {
        error: "TOOLS_INTIIAL_SPEED_BELOW_REQUIRMENTS",
        state: 'warning',
        title: 'Startfart for lav.',
        description: 'Startfart oppfyller ikke krav til minste tillatt startfart før akselerasjonsfelt.',
        autoUnset: false,
    },
    TOOLS_FINAL_SPEED_ABOVE_REQUIRMENTS:
    {
        error: "TOOLS_FINAL_SPEED_ABOVE_REQUIRMENTS",
        state: 'warning',
        title: 'Sluttfart for stor.',
        description: 'Startfart oppfyller ikke krav til maksimal tillatt sluttfart før retardasjonsfelt.',
        autoUnset: false,
    },
    TOOLS_INITIAL_SPEED_EQUAL_OR_ABOVE_SPEELIMIT:
    {
        error: "TOOLS_INITIAL_SPEED_EQUAL_OR_ABOVE_SPEELIMIT",
        state: 'error',
        title: 'Startfart for stor.',
        description: 'Startfart kan ikke være lik eller større enn fartsgrensen.',
        autoUnset: false,
    },
    TOOLS_FINAL_SPEED_EQUAL_OR_ABOVE_SPEELIMIT:
    {
        error: "TOOLS_FINAL_SPEED_EQUAL_OR_ABOVE_SPEELIMIT",
        state: 'error',
        title: 'Sluttfart for stor.',
        description: 'Sluttfart kan ikke være lik eller større enn fartsgrensen.',
        autoUnset: false,
    },
    TOOLS_ACCELERATION_NOT_POSSIBLE_VEHICLE_NOT_ACCELERATING:
    {
        error: "TOOLS_ACCELERATION_NOT_POSSIBLE_VEHICLE_NOT_ACCELERATING",
        state: 'error',
        title: 'Ikke mulig å beregne akselerasjonslengde.',
        description: 'Akselerasjonsfelt kan ikke beregnes for angitte forhold. Kjøretøyet akselererer ikke for angitt stigning.',
        autoUnset: false,
    },
    TOOLS_ACCELERATION_NOT_POSSIBLE_SPEEDLIMIT_ABOVE_VEHICLE_MAX_SPEED:
    {
        error: "TOOLS_ACCELERATION_NOT_POSSIBLE_SPEEDLIMIT_ABOVE_VEHICLE_MAX_SPEED",
        state: 'error',
        title: 'Ikke mulig å beregne akselerasjonslengde.',
        description: 'Fartsgrensen er større enn dimensjonerende kjøretøyets maksimal fart.',
        autoUnset: false,
    },
    TOOLS_ACCELERATION_LENGTH_CORRECTED_TO_TIME_REQUIREMENT:
    {
        error: "TOOLS_ACCELERATION_LENGTH_CORRECTED_TO_TIME_REQUIREMENT",
        state: 'success',
        title: 'Akselerasjonslengden korrigert.',
        description: 'Lengden på akselerasjonsfelt ble korrigert for minst 6 sekunder kjøretid.',
        autoUnset: false,
    },
    TOOLS_RETARDATION_LENGTH_CORRECTED_TO_LENGTH_REQUIREMENT:
    {
        error: 'TOOLS_ACCELERATION_LENGTH_CORRECTED_TO_TIME_REQUIREMENT',
        state: 'success',
        title: 'Retardasjonslengden korrigert',
        description: "Lengden på retardasjonsfelt ble korrigert til minimumsverdien på 40m.",
        autoUnset: true,
    },
    TOOLS_AADT_TOO_LOW:
    {
        error: 'TOOLS_AADT_TOO_LOW',
        state: 'error',
        title: "ÅDT ugyldig",
        description: "Årsdøgntrafikk kan ikke være mindre enn eller lik null."
    },
    TOOLS_AADT_HEAVY_TOO_LOW:
    {
        error: 'TOOLS_AADT_HEAVY_TOO_LOW',
        state: 'error',
        title: "Tungtrafikkandel ugyldig",
        description: "Tungtrafikkandel kan ikke være mindre enn 0%."
    },
    TOOLS_AADT_HEAVY_TOO_HIGH:
    {
        error: 'TOOLS_AADT_HEAVY_TOO_HIGH',
        state: 'error',
        title: "Tungtrafikkandel ugyldig",
        description: "Tungtrafikkandel kan ikke være større enn 100%."
    },
    TOOLS_OVERTAKING_INITIAL_SPEED_ABOVE_SPEEDLIMIT:
    {
        error: 'TOOLS_OVERTAKING_INITIAL_SPEED_ABOVE_SPEEDLIMIT',
        state: 'error',
        title: 'Startfart ugyldig',
        description: 'Startfart kan ikke være større enn fartsgrense.',
        autoUnset: false,
    },
    TOOLS_VERTICAL_GEOMETRY_DATA_INVALID:
    {
        error: 'TOOLS_VERTICAL_GEOMETRY_DATA_INVALID',
        state: 'error',
        title: 'Vertikaldata ugyldig',
        autoUnset: true,
    },
    TOOLS_OVERTAKING_LANE_NOT_NECESSARY_FOR_AADT:
    {
        error: 'TOOLS_OVERTAKING_LANE_NOT_NECESSARY_FOR_AADT',
        state: 'warning',
        title: "Forbikjøringsfelt er ikke nødvendig.",
        description: "Forbikjøringsfelt er ikke nødvendig for angitt ÅDT.",
        autoUnset: true,
    },
    TOOLS_HORIZONTAL_GEOMETRY_DATA_INVALID:
    {
        error: 'TOOLS_VERTICAL_GEOMETRY_DATA_INVALID',
        state: 'error',
        title: 'Horisontaldata ugyldig',
        autoUnset: true,
    },
    TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO:
    {
        error: 'TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO',
        state: 'error',
        title: "Timetrafikk ugyldig.",
        description: "Timetrafikk kan ikke være null.",
        autoUnset: false,
    },
    TOOLS_TURNING_LANE_NOT_NECESSARY:
    {
        error: 'TOOLS_TURNING_LANE_NOT_NECESSARY',
        state: 'success',
        title: "Venstresvingsfelt ikke nødvendig.",
        description: "Venstresvingsfelt er ikke nødvendig ved angitt timetrafikk og fartsgrense.",
        autoUnset: false,
    },
    TOOLS_TUTNING_LANE_LENGTH_CORRECTED:
    {
        error: 'TOOLS_TUTNING_LANE_LENGTH_CORRECTED',
        state: 'success',
        title: "Lengde på kømagasin er korrigert til minstelengde.",
        autoUnset: false,
    },
    TOOLS_TUTNING_LANE_NOT_VALID:
    {
        error: 'TOOLS_TUTNING_LANE_NOT_VALID',
        state: 'error',
        title: "Urealistisk resultat.",
        description: "Beregninger basert på aktuelle inndata gir et uralistisk verdi. Det anbefales å benytte et mer avansert beregningsmodell.",
        autoUnset: false,
    },
    TOOLS_LANE_WIDTH_TOO_LOW:
    {
        error: 'TOOLS_LANE_WIDTH_TOO_LOW',
        state: 'error',
        title: "Ugyldig kjørefeltbredde.",
        description: "Fartsgrensen kan ikke være lavere enn 1 m.",
        autoUnset: false,
    },
    TOOLS_LANE_WIDTH_TOO_HIGH:
    {
        error: 'TOOLS_LANE_WIDTH_TOO_HIGH',
        state: 'error',
        title: "Ugyldig kjørefeltbredde.",
        description: "Fartsgrensen kan ikke være større enn 10 m.",
        autoUnset: false,
    },
    TOOLS_HORIZONTAL_GEOMETRY_TOO_SHORT:
    {
        error: 'TOOLS_HORIZONTAL_GEOMETRY_TOO_SHORT',
        state: 'error',
        title: "Horisontalgeometri for kort.",
        description: "Beregning krever at det er minst 4 horisontalelementer.",
        autoUnset: false,
    },
    TOOLS_SUPERELEVATION_DATA_NEED_MANUAL_CORRECTION:
    {
        error: 'TOOLS_SUPERELEVATION_DATA_NEED_MANUAL_CORRECTION',
        state: 'warning',
        title: 'Tverrfallsdata inneholder feil.',
        description: 'Generert tverrfallsdata inneholder feil/kolisjoner som krever manuell behandling.',
        autoUnset: true,
    },
    TOOLS_TABLE_COPIED_TO_CLIPBOARD:
    {
        error: 'TOOLS_TABLE_COPIED_TO_CLIPBOARD',
        state: 'success',
        title: 'Tabell kopiert til utklipstavlen.',
        autoUnset: true,
    },
    TOOLS_REGULATED_LENGTH_TOO_LOW:
    {
        error: 'TOOLS_REGULATED_LENGTH_TOO_LOW',
        state: 'error',
        title: 'Regulert lengde er ugyldig.',
        description: "Regulert lengde kan ikke være lik eller lavere enn 0.",
        autoUnset: false,
    },
    TOOLS_SIGNAL_REGULATION_NOT_RECOMENDED:
    {
        error: 'TOOLS_SIGNAL_REGULATION_NOT_RECOMENDED',
        state: 'error',
        title: 'Signalregulering ikke anbefalt.',
        description: "Signalregulering frarådes for angitt trafikk og reguleringslengde etter N-V322.",
        autoUnset: false,
    },
    TOOLS_CYCLE_TIME_AND_GREEN_TIME_CORRECTED:
    {
        error: 'TOOLS_CYCLE_TIME_AND_GREEN_TIME_CORRECTED',
        state: 'warning',
        title: 'Grønntid og omløpstid korrigert.',
        description: "Grønntid er korrigert til minste verdi (6 sekunder) og omløpstid utvided.",
        autoUnset: false,
    }
    // #endregion
}